import React from 'react'
import LegendField from 'live/components/widget/config/forms/legend'

import { ConfigProps } from './Interface'

export default function Config(props: ConfigProps) {
    return (
        <div>
            {/* <LegendField
                dark={false}
                config={props.config.legend}
                onChangeLayoutConfig={event => props.onChange('legend', event)}
                patchConfigs={true}
                styles={{
                    left: 0,
                    bottom: 0
                }}
            /> */}
        </div>
    )
}
